import Typography from '../../../atoms/typography'
import { Root, GridContainer, GridBorder, Title, Description } from './features.styled'
import { useIntl } from 'react-intl'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import RichContent from '../../../particles/rich-content'
import isArray from 'lodash/isArray'

const Features = () => {
	const { formatMessage } = useIntl()

	const {
		catalog: {
			products: {
				features: { enabled: featuresEnabled, attributes: featuresAttributes },
			},
		},
	} = useConfig()

	const productContextValue = useProductContext()

	const [{ product }] = productContextValue

	return (
		featuresEnabled &&
		featuresAttributes?.length > 0 && (
			<Root>
				<Typography variant="h3" mb={3.5}>
					{formatMessage({ id: 'features_title' })}
				</Typography>
				<GridContainer>
					{featuresAttributes.map((attributeCode, index) => {
						const attribute = product[attributeCode] ?? product.attributes[attributeCode]
						return attribute?.length > 0 || attribute?.value?.length > 0 ? (
							<GridBorder key={index}>
								<Title variant="h5">
									{product[attributeCode] ? formatMessage({ id: 'features_' + attributeCode }) : attribute.label}
								</Title>
								<Description color="grey.dark">
									{isArray(attribute.value) ? (
										attribute.value.map((value, index) => <RichContent key={index} content={value} />)
									) : (
										<RichContent content={product[attributeCode] ? attribute : attribute.value} />
									)}
								</Description>
							</GridBorder>
						) : null
					})}
				</GridContainer>
			</Root>
		)
	)
}

export default Features
